import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../hook/useAppSelector';
import { PayInPayOut } from '../../../interface/response/CashRegisterDataResponse';
import MoneyRow from './MoneyRow';
import { stringToColor } from '../../../util/stringToColor';
import { t } from 'i18next';
import { CashRegisterDetailsResponse } from '../../../interface/response/CashRegisterDetailsResponse';

const Managers = () => {
  const cashRegisterDetails = useAppSelector((state) => state.cashRegisterDetails);
  const [managers, setManagers] = useState<CashRegisterDetailsResponse['Managers']>(cashRegisterDetails.data?.Managers);

  useEffect(() => {
    setManagers(cashRegisterDetails.data?.Managers || []);
  }, [cashRegisterDetails.data]);

  return (
    <div className="managers_container container">
      <div className="item">
        <span className="title">
          {t('cashRegister.table.details.cashRegisterDetails.manualCashRegisterPayInsAndPayOuts')}
        </span>
        <div className="values">
          <MoneyRow label={t('cashRegister.table.details.payIn')} amount={managers?.PayInPayOutSum?.PayIn} />
          <MoneyRow label={t('cashRegister.table.details.payOut')} amount={managers?.PayInPayOutSum?.PayOut} />
          <MoneyRow label={t('cashRegister.table.details.balance')} amount={managers?.PayInPayOutSum?.Balance} />
        </div>
      </div>

      {managers?.PayInPayOut?.length > 0 && (
        <>
          <hr />
          <span className="title">{t('cashRegister.table.details.cashRegisterDetails.listOfManagers')}</span>
        </>
      )}

      {managers?.PayInPayOut?.map((manager: PayInPayOut, index: number) => (
        <div className={`manager_item item ${index === 0 ? 'first_manager' : ''}`} key={`${manager}_${index}`}>
          <div className="managers values" key={`${manager.FullName}_${index}`}>
            <div className="manager_info info">
              <span className="initials" style={{ backgroundColor: stringToColor(manager.FullName) }}>
                {manager.FullName.split(' ')
                  .map((n) => n[0])
                  .join('')}
              </span>
              <span className="manager_name name">{manager.FullName}</span>
            </div>
            <div className="values">
              <MoneyRow label={t('cashRegister.table.details.payIn')} amount={manager.PayIn} />
              <MoneyRow label={t('cashRegister.table.details.payOut')} amount={manager.PayOut} />
              <MoneyRow label={t('cashRegister.table.details.balance')} amount={manager.Balance} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Managers;
